// Helper para padronizar exibição do nome das lojas
// Formato: "ID - NOME_COMPLETO" (ex: "1 - MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.01")

export function getLojaNome(clienteId, clientes = []) {
  const idNum = Number(clienteId);
  try {
    if (Array.isArray(clientes) && clientes.length > 0) {
      const c = clientes.find((x) => Number(x.id) === idNum);
      if (c && c.nome) {
        return `${idNum} - ${String(c.nome).toUpperCase().trim()}`;
      }
    }
  } catch (_) {
    /* noop */
  }
  // Fallback se não encontrar o cliente
  const map = {
    1: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.01',
    2: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.02',
    3: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.03',
    4: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.04',
    5: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.05',
    6: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.06',
    7: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.07',
    8: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.08',
    9: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.09',
    10: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.10',
    11: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.11',
    12: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.12',
    13: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.13',
    14: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.14',
    15: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.15',
    16: 'MERCADAO ATACADISTA COMERCIAL DE ALIMENTOS LTDA.16',
  };
  const nome = map[idNum] || `LOJA ${String(idNum).padStart(2, '0')}`;
  return `${idNum} - ${nome}`;
}
